var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7324 18.4355C11.1924 19.0255 11.9124 19.4155 12.7124 19.4155C14.0924 19.4155 15.2124 18.2955 15.2124 16.9155C15.2124 16.3455 15.0224 15.8155 14.7024 15.3955",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.53289 21.7155C2.92289 20.9555 2.71289 19.7455 2.71289 17.9155V15.9155C2.71289 11.9155 3.71289 10.9155 7.71289 10.9155H17.7129C18.0729 10.9155 18.4029 10.9255 18.7129 10.9455C21.8829 11.1255 22.7129 12.2755 22.7129 15.9155V17.9155C22.7129 21.9155 21.7129 22.9155 17.7129 22.9155H7.71289C7.35289 22.9155 7.02289 22.9055 6.71289 22.8855",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71289 10.9155V8.91553C6.71289 5.60553 7.71289 2.91553 12.7129 2.91553C16.8629 2.91553 18.2529 4.29553 18.6129 6.47553",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7129 2.91553L2.71289 22.9155",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.6088f61e.svg";
export { ForwardRef as ReactComponent };